<template>
  <div class="events">
    <div class="container"> 
      <h1 class="headline">GCO Events</h1>
      <div class="loading" v-if="events == null"></div> 
      <h2 class="headline">{{$t('message.tournaments')}}</h2>
      <div class="simple-list-outer" v-if="events != null">  
      
        <div class="list-item-expandable" v-for="item in events.tournaments" :key="item.id" @click="selectEvent(item.id)" :class="{open: item.id === selectedEventId}">  
          <div class="list-item">  
            <div class="list-item-image"><img :src="posterPath + '?posterId=' + item.id + '&targetwidth=33&targetheight=50'"/></div>
            <div class="list-item-caption">
              <div class="list-item-title">{{item.title}}</div>
              <div class="list-item-subtitle">{{item.startDate}} <span v-if="item.endDate !== '' && item.endDate !== item.startDate">- {{item.endDate}}</span></div>
            </div>
            <div class="list-item-additionals">                      
              <div class="list-item-additional address">      
                <a class="address-locator" :href="'https://maps.google.com/?q=' + item.street + ' ' + item.zip + ' ' + item.city" target="_blank"></a>        
                <div>                      
                  <div>{{item.street}}</div>            
                  <div>{{item.postcode}} {{item.city}}</div>            
                </div>
              </div>                      
            </div>             
          </div> 
          <div class="list-item-expandable-content" >
            <img :src="posterPath + '?posterId=' + item.id + '&targetwidth=495&targetheight=750'"/>
            <div>{{item.txt}}</div>
            <a :href="item.link" target="_blank">{{$t('message.more')}}</a>
          </div> 
        </div> 
       
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'events',
  data () {
    return {
      test: null,
      selectedEventId: 0
    }
  },
  methods: {
    getEvents: function () {
      this.$store.dispatch('events/getAll')
    },
    selectEvent: function (id) {
      if (this.selectedEventId === id) {
        this.selectedEventId = 0
      } else {
        this.selectedEventId = id
      }
    }
  },
  computed: {
    ...mapGetters({
      events: 'events/list',
      flagsPath: 'countries/flagsPath',
      posterPath: 'events/eventPosterPath'
    })
  },
  created: function () {
    this.getEvents()
  }
}
</script>
